import React from 'react'
import PropTypes from 'prop-types'
import { isBrowser, isTablet } from 'react-device-detect'
import PdfExport from '../../../../../../components/pdf/PdfExport'
import Glyph from '../../../../../../LEGACY/Glyph'
import { Button, PageHeader } from '@lmc/ui-kit'
import { history } from 'store'
import { Link } from 'react-router-dom'
import ExternalLink from 'components/icons/ExternalLink'

export default function MedStockHeader(props) {
  const {
    isPDF,
    startDate,
    endDate,
    item,
    medication,
    openStockLogModal,
    resident,
    router,
    testId
  } = props

  const title = isPDF
    ? `${resident.name.first} ${resident.name.last} - ${medication.name}`
    : `Stock - ${medication.name}`
  const subtitle = isPDF && `Stock Count`
  const pdfUrl = `residents/${router.params.id}/pdf/emar/${
    router.params.medication_id
  }/stock?printpdf=1&startDate=${startDate?.format('YYYY-MM-DD')}&endDate=${endDate?.format('YYYY-MM-DD')}`
  const url = `/api/services/pdf/export?url=${encodeURIComponent(pdfUrl)}`

  return (
    <PageHeader
      onBack={() => history.back()}
      title={title}
      subtitle={subtitle}
      testId={testId ? `${testId}-med-stock-header` : 'med-stock-header'}
    >
      <div
        style={{ display: 'flex', gap: 8 }}
        data-testid={
          testId ? `${testId}-med-stock-actions` : 'med-stock-actions'
        }
      >
        <Link
          to="https://support.logmycare.co.uk/en/collections/2749236-medication-administration-emar"
          target="_blank"
          rel="noreferrer"
          style={styles.readMoreLink}
          data-testid={
            testId ? `${testId}-stock-read-more-link` : 'stock-read-more-link'
          }
        >
          Read more <ExternalLink />
        </Link>
        {!isPDF && (
          <div
            style={styles.pdfBtn}
            data-testid={
              testId ? `${testId}-stock-pdf-container` : 'stock-pdf-container'
            }
          >
            <PdfExport
              pdfTitle="Stock Count"
              url={url}
              text={isDesktop ? 'Download PDF' : 'PDF'}
              data-testid={
                testId
                  ? `${testId}-stock-download-pdf-btn`
                  : 'stock-download-pdf-btn'
              }
            />
          </div>
        )}
        {!isPDF && (
          <Button
            id="add-stock-log-button"
            onClick={() =>
              openStockLogModal({
                resident: router.params.id,
                medication: router.params.medication_id,
                item: item.id,
                category: item.category
              })
            }
            style={styles.addMedicationButton}
            variant="primary"
            icon={<Glyph name="plus" />}
            data-testid={
              testId ? `${testId}-add-stock-count-btn` : 'add-stock-count-btn'
            }
            // disabled={home && !home.features?.emarOnboarded?.enabled && !chartData.length}
          >
            Stock Count
          </Button>
        )}
      </div>
    </PageHeader>
  )
}

MedStockHeader.propTypes = {
  isPDF: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  item: PropTypes.object,
  medication: PropTypes.object.isRequired,
  openStockLogModal: PropTypes.func.isRequired,
  resident: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  testId: PropTypes.string
}

const isDesktop = isBrowser || isTablet

const styles = {
  pdfBtn: {
    whiteSpace: 'nowrap'
  },
  addMedicationButton: {
    whiteSpace: 'nowrap'
  },
  readMoreLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    whiteSpace: 'nowrap'
  }
}
